export function initHeroProjectsPreview() {
    const hero = document.querySelector('.heroProjectsPreview');
    if (!hero) return;

    const rows = hero.querySelectorAll('.dcProjectsPreviewRow__content');
    if (!rows.length) return;

    let isPlaying = true;

    const button = document.createElement('button');
    button.className = 'heroProjectsPreview__playPause';
    button.setAttribute('aria-label', 'Pause animation');
    button.innerHTML = '<i class="icon icon-pause" aria-hidden="true"></i>';

    button.addEventListener('click', () => {
        isPlaying = !isPlaying;

        rows.forEach(row => {
            row.style.animationPlayState = isPlaying ? 'running' : 'paused';
        });

        button.innerHTML = isPlaying
            ? '<i class="icon icon-pause" aria-hidden="true"></i>'
            : '<i class="icon icon-play" aria-hidden="true"></i>';
        button.setAttribute('aria-label', isPlaying ? 'Pause animation' : 'Play animation');
    });

    hero.appendChild(button);
}